import { SiteGroupDtoToEntity } from "src/app/features/SiteGroup/services/mappers/SiteGroupDtoToEntity";
import type { SiteGroupDto } from "src/app/features/SiteGroup/types/SiteGroupDto";
import type { SiteGroupEntity } from "src/app/features/SiteGroup/types/SiteGroupEntity";
import type { ListResponseDto } from "../../../../../core/types/be/ListResponseDto";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const SiteGroupTableDtoMapper = (input: Readonly<ResourcePageDto<SiteGroupDto>>): ResourcePageEntity<SiteGroupEntity> => {
    return {
        list: input.list ? input.list.map(SiteGroupDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};

export const SiteContractsTableMapper = (input: Readonly<ListResponseDto<SiteGroupDto>>): ResourcePageEntity<SiteGroupEntity> => {
    return {
        list: input.items,
        currentPage: undefined,
        totalPages: undefined,
        totalNumberOfResults: undefined,
    };
};
